import { useState, useEffect } from 'react';
import api from '../api';

// Valori attivi di un elenco modificabile (es. 'tipo_f24'); se attivo=false non carica nulla
export default function useElenco(elenco, attivo = true) {
  const [valori, setValori] = useState([]);
  useEffect(() => {
    if (!attivo) return undefined;
    let annullato = false;
    api.get(`/competenze/elenchi/${elenco}`).then(r => { if (!annullato) setValori(r.data); }).catch(() => {});
    return () => { annullato = true; };
  }, [elenco, attivo]);
  return valori;
}
